export default __webpack_public_path__ + "static/media/manage-content-active.ec0e8a45.svg";